// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/presentation.js';

import { paths } from '../generated/presentation';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('presentation', Original, paths);
